import React, { FC, memo } from 'react';

import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  width?: string;
  height?: string;
  strokeColor?: string;
  className?: string;
}

const Share: FC<Props> = ({
  className,
  height = '1.5rem',
  strokeColor = colors.lapel,
  width = '1.5rem',
}) => (
  <Svg className={className} height={height} title="share icon" viewBox="0 0 24 24" width={width}>
    <path
      d="M7,8.39a.5.5,0,0,0,.36-.16L11,4.38V16.44a.5.5,0,0,0,1,0V4.38l3.64,3.85a.5.5,0,1,0,.73-.69l-4.5-4.77a.52.52,0,0,0-.73,0L6.64,7.54A.5.5,0,0,0,7,8.39Z"
      fill={strokeColor}
    />
    <path
      d="M20.5,13.06a.5.5,0,0,0-.5.5v4.55A2.89,2.89,0,0,1,17.11,21H5.89A2.89,2.89,0,0,1,3,18.11V13.56a.5.5,0,1,0-1,0v4.55A3.89,3.89,0,0,0,5.89,22H17.11A3.89,3.89,0,0,0,21,18.11V13.56A.5.5,0,0,0,20.5,13.06Z"
      fill={strokeColor}
    />
  </Svg>
);

export default memo(Share);
